module.exports = __webpack_public_path__ + "img/CoastWatchers_logo.7cf25457.png";